import { TFunction } from '@lyearn/i18n';
import { Edit2Outline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';

import { DetailsActionDialogs } from '../types';

export const PARENT_ENTITY_ID = 'parentEntityId';

export const EXERCISE_REPORT_QUERY_KEY = 'exercise_report_data';

export const JOURNEY_SESSION_ID = 'sessionId';

export const getActionMenuItems = (t: TFunction): ActionMenuItemType[] => [
  {
    id: DetailsActionDialogs.ReviewerSettings,
    label: t('Exercise:ReviewerSettings'),
    EndIcon: Edit2Outline,
  },
];
